

























































import Vue from 'vue'

export default Vue.extend({
  props: {
    recipient: {
      type: Object,
      default() {
        return {}
      }
    },
    provider: {
      type: String
    }
  },
  methods: {
    hasProfileName(): boolean {
      return !!this.provider
    },

    getMicroCreditLabel(recipient: any) {
      return recipient.profilename &&
        recipient.profilename.includes('Subscriber Microcredit Profile')
        ? 'OUI'
        : 'NON'
    },

    getStatusLabel(recipient: any) {
      return ({
        success: 'Actif',
        active: 'Actif',
        failed: 'Inactif)'
      } as Record<string, string>)[recipient.status.toLowerCase()]
    },

    isEligible(recipient: any): boolean {
      return this.getMicroCreditLabel(recipient) === 'OUI'
    }
  },
  computed: {
    providerName(): string {
      return this.provider
    },
    isActifRecipient(): boolean {
      return (
        this.recipient.status === 'ACTIVE' ||
        this.recipient.status === 'SUCCESS'
      )
    },
    isNotActifRecipient(): boolean {
      console.log('rec:', this.recipient, this.providerName)
      if (this.recipient.status === 'FAILED') {
        return true
      }
      if (!this.providerName) {
        return false
      }

      console.log(
        'here...',
        this.recipient.status &&
          ['ACTIVE', 'SUCCESS'].includes(this.recipient.status)
      )

      return !(
        this.recipient.status &&
        ['ACTIVE', 'SUCCESS'].includes(this.recipient.status)
      )
    }
  }
})
